import { createStyles } from '@/styles';

export default createStyles(() => ({
  classes: {
    close: 'ml-auto mr-0 text-fg-subtle',
  },
}));
